<template>
  <page-view title="入库审核列表">
    <template slot="action">
    </template>
    <a-card>
      <expert-s-table ref="expertSTable" :from-type="ExpertFromType.STOCK_IN"/>
    </a-card>
  </page-view>
</template>

<script>
import { PageView } from '@/layouts'
import expertSTable from '@/epp/expertmain/expertInfo/common/ExpertSTable.vue'
import { ExpertFromType } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'

export default {
  name: 'expertStockIn',
  computed: {
    ExpertFromType () {
      return ExpertFromType
    }
  },
  components: {
    PageView,
    expertSTable
  },
  data () {
    return {}
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.ant-calendar-picker {
  width: 47% !important;
}
</style>
